import { render, staticRenderFns } from "./KeysPanel.vue?vue&type=template&id=4c32cc1b&scoped=true&"
import script from "./KeysPanel.vue?vue&type=script&lang=js&"
export * from "./KeysPanel.vue?vue&type=script&lang=js&"
import style0 from "./KeysPanel.vue?vue&type=style&index=0&id=4c32cc1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c32cc1b",
  null
  
)

export default component.exports